import { ComponentType, FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { applyThemeOverrides } from "../config/theme";
import FenerbahceTheme from "../fenerbahce/FenerbahceTheme";
import { isFenerbahceFan } from "../fenerbahce/fans";
import { useCurrentUser } from "../lib/useCurrentUser";
import { getActiveUser } from "../../utils/SsoSession";
import "../styles/tokens.css";
import "../styles/base.css";
import "../ui/ui.css";
import "./shell.css";
import Header from "./Header";

interface Props {
  view: ComponentType<any>;
}

/**
 * Redesign altındaki bütün CSS kuralları kökteki `sso-rd` sınıfının altına
 * yazılmıştır; hiçbir stil eski ekranlara sızmaz.
 */
const AppShell: FC<Props> = ({ view: View }) => {
  const { i18n } = useTranslation();
  const profile = useCurrentUser();
  const isFan =
    isFenerbahceFan(getActiveUser()?.username) || isFenerbahceFan(profile?.username);

  useEffect(() => {
    applyThemeOverrides();
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18n.language?.startsWith("en") ? "en" : "tr";
  }, [i18n.language]);

  /*
   * Sayfanın kaydırma çubuğu `html` üzerinde, yani `.sso-rd` kökünün dışında; kural
   * doğrudan `:root`a yazılsaydı eski ekranlara da sızardı.
   */
  useEffect(() => {
    document.documentElement.classList.add("sso-rd-root");
    return () => document.documentElement.classList.remove("sso-rd-root");
  }, []);

  return (
    <div className="sso-rd">
      <Header />
      <main>
        <View />
      </main>
      {isFan && <FenerbahceTheme />}
    </div>
  );
};

export default AppShell;
